<kendo-card class="{{ departmentClass }}" >
  <kendo-card-header >
    <div>

      <h1 kendoCardTitle >
        <span *ngIf="filelinkBack != 9999" class="card_icon k-icon k-i-undo k-color-primary k-icon-md" (click)="ZoomInCard(filelinkBack)"></span>
        <span class="card_icon k-icon k-i-home k-color-primary k-icon-md" (click)="Home()"></span>
        {{ card.name }}

        <span *ngIf="card.id != 0" class="card_icon k-icon k-i-redo k-color-primary k-icon-md" (click)="ZoomInCard(card.id)"></span>
      </h1>
      <div kendoCardSubtitle>
        <div id="wrap">
          <div id="one"> Card ID:  {{ card.id  }} </div>
          <div id="three"> Back:     {{ filelinkBack }} </div>
        </div>
      </div>
    </div>
  </kendo-card-header>
  <hr kendoCardSeparator/>
  <kendo-card-body >

    <table class="complex">
      <tr>
        <td *ngFor="let complexObject of card.complexObjects ;let y = index">
          <app-card-gauge *ngIf="complexObject.actual.variable.id > 0" [complexObject]="complexObject"></app-card-gauge>
        </td>
      </tr>
    </table>

    <div *ngFor="let branch of card.branches ; let i = index">
      <app-branch-type-math-valve             *ngIf="branch.branchType==eJSON_BRANCH_TYPE.eBRANCH_TYPE_MATH_VALVE_DETAIL"     [branchMathValve]="branch"></app-branch-type-math-valve>
      <app-branch-type-out-side-overview      *ngIf="branch.branchType==eJSON_BRANCH_TYPE.eBRANCH_TYPE_OUTSIDE_OVERVIEW"      [branchOutside]="branch"></app-branch-type-out-side-overview>
      <app-branch-type-furti-valve-component  *ngIf="branch.branchType==eJSON_BRANCH_TYPE.eBRANCH_TYPE_FURTI_VALVE_DETAIL"    [branchFurtiValve]="branch"></app-branch-type-furti-valve-component>
      <app-branch-type-single-valve-summary   *ngIf="branch.branchType==eJSON_BRANCH_TYPE.eBRANCH_TYPE_SINGLE_VALVE_SUMMARY"  [branchMathValve]="branch"></app-branch-type-single-valve-summary>
      <app-branch-type-zone-overview          *ngIf="branch.branchType==eJSON_BRANCH_TYPE.eBRANCH_TYPE_ZONE_OVERVIEW"         [branchZoneOverview]="branch"></app-branch-type-zone-overview>
      <app-branch-type-day-supply-overview-component    *ngIf="branch.branchType==eJSON_BRANCH_TYPE.eBRANCH_TYPE_DAYSUPPLY_OVERVIEW"    [branchDaySupplyOverview]="branch"></app-branch-type-day-supply-overview-component>
      <app-branch-type-unit-overview                    *ngIf="branch.branchType==eJSON_BRANCH_TYPE.eBRANCH_TYPE_UNIT_OVERVIEW"    [branchUnitOverview]="branch"></app-branch-type-unit-overview>
      <app-branch-type-afarm-overview                   *ngIf="branch.branchType==eJSON_BRANCH_TYPE.eBRANCH_TYPE_AFARM_OVERVIEW"   [branchAfarmOverview]="branch"></app-branch-type-afarm-overview>
    </div>


    <table class="lines">
      <tr *ngFor="let line of card.lines ; let i = index">
        <td>
          <div> <p><app-line [line]="line"></app-line> </p> </div>
        </td>
      </tr>
    </table>

  </kendo-card-body>
  <kendo-card-footer>
  </kendo-card-footer>

</kendo-card>




